const endpoints = {
    checkEmail: '/check_email',
    register: '/register',
    login: '/login',
    loginScanPage: '/login_scan_page',
    refresh: '/user/refresh-token',
    profile: '/user/profile',
    password: '/user/password',
    forgotPassword: {
        sendEmail: '/forgot_password/send_email',
        newPassword: '/forgot_password/change_password',
        checkToken: '/forgot_password/check_token'
    },
    // /oauth/connect/{service}
    // /oauth/check/{service}
    socialCheck: '/oauth/check/',
    products: '/products',
    productImg: (id) => `/products/${id}/images`,
    singleProduct: (id) => `/products/${id}`,
    printProduct: (id) => `/products/${id}/print-labels`,
    addToRestock: (id) => `/products/${id}/add-to-restock-plan`,
    addToReturn: (id) => `/products/${id}/add-to-return-order`,
    addToArchive: (id) => `/products/${id}/archive`,
    categories: '/product/categories',
    incomesShipment: '/incomes',
    income: (id) => `/incomes/${id}`,
    incomesPlans: '/incomes/plans',
    incomePrint: (id) => `incomes/${id}/print-labels`,
    incomeCancel: (id) => `/incomes/${id}/cancel`,
    incomeAddresse: id => `incomes/${id}/address`,
    incomesItems: (id) => `/incomes/${id}/items`,
    incomesParcels: (id) => `incomes/${id}/parcels`,
    incomesItemProduct: (id, itemId) => `/incomes/${id}/items/${itemId}`,
    incomesDeliveryOffers: (id) => `/incomes/${id}/delivery-offers`,
    incomesApplyDelivery: (id) => `/incomes/${id}/apply-delivery`,
    createShipment: (id) => `incomes/${id}/create-shipment`,
    printShipment: (id) => `shipment/${id}/pdf_export`,
    countries: '/address/countries',
    userAddresses: '/user/address',
    userAddress: (id) => `/user/address/${id}`,
    orders: {
        list: '/orders',
        single: id => `/orders/${id}`,
        fulfillment: id => `/orders/${id}/fulfillment`,
        fulfillmentAll: '/orders_fulfillment',
        cancellation: id => `/orders/${id}/cancellation`,
        products: id => `/orders/${id}/products`,
        product: (id, productId) => `/orders/${id}/products/${productId}`,
        addProductsToOrder: (orderId) => `add_products_order/${orderId}`,
        deliveryOffers: id => `/orders/${id}/delivery-offers`,
        getDeliveryLocker: (query) => `/delivery-locker?${query}`,
        getDeliveryLockerList: (query) => `/delivery-lockers`,
        applyDelivery: (id, query) => `/orders/${id}/apply-delivery?${query}`,
        scanOrders: `/scan_orders`,
        scanOrdersByProductId: (orderId, productId) => `/scan_orders/${orderId}/products/${productId}`,
        scanOrdersByOrderId: (orderId) => `/scan_orders/${orderId}`,
        scanOrdersByOrderIdLabelKey: (orderId) => `/scan_orders/${orderId}/label`,
        scanOrdersCompleted: `/scan_orders_completed`,
        scanOrdersByProductFnsku: (orderId) => `scan_orders/${orderId}/product_fnsku`
    },
    market: market => `/marketplace${market ? '/' + market : ''}`,
    deliveryServices: '/delivery-services',
    settings: {
        fulfillment: '/user/settings/fulfillment'
    }
}

export default endpoints



// WEBPACK FOOTER //
// ./src/api/endpoints.js